import { createSlice } from "@reduxjs/toolkit";
import { ProfileWorkBefore } from "core/http/service/operationProcess/resTypes";

import { set, uniqueId } from "lodash";

interface InitialState {
  data: {
    jobs: ProfileWorkBefore[];
  };
}

const initialState: InitialState = {
  data: {
    jobs: [],
  },
};

const formEditProfileWorkBeforeSlice = createSlice({
  name: "formEditProfileWorkBefore",
  initialState,
  reducers: {
    updateFormProfileWorkBefore: (state, action) => {
      const keys = Object.keys(action.payload);
      for (let i = 0; i < keys.length; i++) {
        set(state.data, keys[i], action.payload[keys[i]]);
      }
    },
    addMoreProfileWorkBefore: (state) => {
      state.data.jobs = [
        ...(state.data.jobs ?? []),
        {
          uuid: uniqueId(),
          departmentName: "",
          fromDate: null,
          organizationName: "",
          otherDescription: "",
          positionName: "",
          salary: 0,
          toDate: null,
        },
      ];
    },
    removeLastItemProfileWorkBefore: (state) => {
      state.data.jobs = state.data.jobs.slice(0, -1);
    },
    resetFormEditProfileWorkBefore: () => {
      return { ...initialState };
    },
  },
});

export const {
  updateFormProfileWorkBefore,
  addMoreProfileWorkBefore,
  resetFormEditProfileWorkBefore,
  removeLastItemProfileWorkBefore,
} = formEditProfileWorkBeforeSlice.actions;

export default formEditProfileWorkBeforeSlice.reducer;
